import React from 'react'

import { HourConfig } from '../../../../types/blueprint'

import { ListModal, Column } from '@/components/form-components/ListModal'

const COLUMNS: Column[] = [
  {
    name: 'label',
    label: 'Label',
    inputType: 'text',
    placeholder: 'Full day',
    defaultValue: '',
  },
  {
    name: 'hours',
    label: 'Hours',
    inputType: 'number',
    defaultValue: 0,
  },
]

type Props = {
  value: HourConfig[]
  onChange: (value: HourConfig[]) => void
}

export const HourConfigInput: React.FC<Props> = ({ value, onChange }) => {
  return (
    <ListModal
      columns={COLUMNS}
      value={value}
      onChange={onChange}
      buttonText="Edit hours"
      modalTitle="Configure Worker hour presets"
    />
  )
}
